import { wait } from "../lib/helpers";

export function useWeeklyMenuReturningCustomers() {
  async function RCForm(form) {
    if (!(form instanceof Element)) {
      return;
    }

    const oldC = form.querySelector(".confirm-returning-customer");

    const alreadyCustomer =
      localStorage.getItem("redApronUser") === "true" ? true : false;

    if (!alreadyCustomer) {
      form.classList.add("transition-out");
      form.classList.add("active");
      await wait(200);
      form.classList.remove("transition-out");
    }

    async function handleOld(e) {
      form.classList.add("transition-out");
      await wait(200);
      form.classList.remove("active");
    }

    oldC.addEventListener("click", handleOld);
  }

  const rcForm = document.querySelector(".returning-customer");

  RCForm(rcForm);
}
